module.exports = __webpack_public_path__ + "img/nightingale_title--forbid.aa9794ba.png";